/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React from "react";

import { Typography } from "@material-ui/core";

import JSONViewer from "./JSON/JSONViewer";
// import DOCViewer from "./DOC/DOCViewer";
// import TABLEViewer from "./TABLE/TableViewer/TABLEViewer";
import DataViewer from "./DataViewer/DataViewer";

const Viewers = {
  json: JSONViewer,
  data: DataViewer
};

let getViewer = (instance, additional_props) => {
  console.log("Viewer Instance :", instance);
  console.log("Additional Props: ", additional_props);
  return React.createElement(Viewers[instance.viewer], {
    key: instance.id,
    config: instance.config,
    record: instance.record,
    edit: instance.edit,
    params : instance.config.params,
    ...additional_props,
  });
};

export default (instance, additional_props) => {
  if (typeof Viewers[instance.viewer] !== "undefined") {
    return getViewer(instance, additional_props);
  } else {
    return (
      <Typography>
        <em>{instance.viewer}</em> viewer is not supported
      </Typography>
    );
  }
};
